var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class Sunbrite {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        this.framework = framework;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        this.keyCodes = {
            key0: '0',
            key1: '1',
            key2: '2',
            key3: '3',
            key4: '4',
            key5: '5',
            key6: '6',
            key7: '7',
            key8: '8',
            key9: '9',
            keyDash: '-',
        };
        this.tuners = {
            '1': 'air',
            '2': 'cable',
        };
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.channelKeyboardType = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () { return 'numericWithDash'; }),
        };
        this.channelTuner = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1ARCB ?`, /%1ARCB=(\d+)/i, tags);
                const tuner = this.tuners[match[1]];
                if (tuner === undefined)
                    throw new Error(`unsupported tune mode: ${match[1]}`);
                return tuner;
            }),
        };
        this.channelTuners = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return ['air', 'cable'];
            }),
        };
        this.displayBlank = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1AVMT ?`, /%1AVMT=(\d+)|ERR|WAIT/i, tags);
                // Check for either audio-and-video Mute or just video-Mute.
                if (match[1])
                    return match[1] === '31' || match[1] === '11';
                return this.state.displayBlank.value;
            }),
            set: (blank, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1AVMT ${blank ? '31' : '30'}`, // Set to audio-and-video mute.
                /%1AVMT=(OK)|ERR/i, tags);
                if (match[1])
                    return blank;
                return this.state.displayBlank.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1SWVE ?`, /%1SWVE=(.+)/i, tags);
                return match[1];
            }),
            powerOffRestrictions: ['get'],
        };
        this.mediaOperation = {
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                if (value.operation === 'channelSet') {
                    yield this.socket.sendAsync(`%1CHAN ${value.channel}`, tags);
                }
                else if (value.operation === 'channelTunerSet') {
                    const tunerEntry = Object.entries(this.tuners).find(e => e[1] === value.channelTuner);
                    if (tunerEntry === undefined) {
                        throw new Error(`unsupported channel tuner: ${value}`);
                    }
                    yield this.socket.sendAsync(`%1ARCB ${tunerEntry[0]}`, tags);
                }
                else if (value.operation === 'channelDown') {
                    yield this.socket.sendAsync(`%1CHNA 0`, tags);
                }
                else if (value.operation === 'channelUp') {
                    yield this.socket.sendAsync(`%1CHNA 1`, tags);
                }
                else if (value.operation === 'closedCaptioningToggle') {
                    yield this.socket.sendAsync(`%1CLCP 1`, tags);
                }
                else if (value.operation === 'directionDown') {
                    yield this.socket.sendAsync(`%1ARRO 1`, tags);
                }
                else if (value.operation === 'directionUp') {
                    yield this.socket.sendAsync(`%1ARRO 0`, tags);
                }
                else if (value.operation === 'directionLeft') {
                    yield this.socket.sendAsync(`%1ARRO 2`, tags);
                }
                else if (value.operation === 'directionRight') {
                    yield this.socket.sendAsync(`%1ARRO 3`, tags);
                    // } else if (value.operation === 'enter') {
                    //     await this.socket.sendAsync(`%1ENTR 1`, tags);
                }
                else if (value.operation === 'info') {
                    yield this.socket.sendAsync(`%1INFO 0`, tags);
                }
                else if (value.operation === 'keyEnter' || value.operation === 'directionEnter') {
                    yield this.socket.sendAsync(`%1ENTR 1`, tags);
                }
                else if (value.operation === 'menu') {
                    yield this.socket.sendAsync(`%1MENU 0`, tags);
                }
                else if (value.operation === 'channelPrevious') {
                    yield this.socket.sendAsync(`%1CHRT 1`, tags);
                }
                else if (Object.keys(this.keyCodes).includes(value.operation)) {
                    const code = this.keyCodes[value.operation];
                    // there is no response from the device for the KK commands
                    yield this.socket.sendAsync(`%1NUMB ${code}`, tags);
                }
                else {
                    this.log.error(`unhandled media operation: ${value.operation}`);
                }
                return value;
            }),
            powerOffRestrictions: ['set'],
        };
        this.mediaOperations = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const mediaOperationCaps = {};
                const mediaOperations = [
                    'channelPrevious',
                    'channelSet',
                    'channelTunerSet',
                    'channelUpDown',
                    'closedCaptioningToggle',
                    'directionUpDownLeftRight',
                    'directionEnter',
                    'info',
                    'keyDash',
                    'keyDigits',
                    'keyEnter',
                    'menu',
                ];
                for (const input of Object.values((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.videoInputs) !== null && _b !== void 0 ? _b : {})) {
                    if (input.code === '1') {
                        mediaOperationCaps[input.code] = [...mediaOperations];
                    }
                }
                return mediaOperationCaps;
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1POWR ?`, /%1POWR=(\d)|OK|ERR|WAIT|UNSELECTED/i, tags);
                if (match[1])
                    return match[1] === '1' || match[1] === '3';
                return this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                this.busyTimeout.clear();
                this.framework.suspendPolling(power ? 15000 : 10000);
                const match = yield this.socket.send(`%1POWR ${power ? '1' : '0'}`, /%1POWR=(OK|ERR|WAIT|UNSELECTED)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 15000 : 10000);
                if (match[1] === 'OK')
                    return power;
                return this.state.power.value;
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1INPT ?`, /%1INPT=(\d+)|ERR|WAIT/i, tags);
                if (match[1])
                    return match[1];
                return this.state.videoInput.value;
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1INPT ${code}`, /%1INPT=(OK)|ERR/i, tags);
                this.busyTimeout.clear();
                this.state.busy.update(true);
                this.state.videoInput.update(code); // provide immediate feedback since we will delay
                yield this.timeouts.delay(2000); // allow time for input to set before room power off
                this.state.busy.update(false);
                if (match[1])
                    return code;
                return this.state.videoInput.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1VOLU ?`, /%1VOLU=(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1VOLU ${volume.toString().padStart(3, '0')}`, /%1VOLU=(\d+|OK|ERR)/i, tags);
                if (match[1].toLowerCase() === 'ok')
                    return volume;
                if (match[1].toLowerCase() === 'err')
                    return this.state.volume.value;
                return parseInt(match[1], 10);
            }),
            range: { max: 100, min: 0, round: 1 },
            powerOffRestrictions: ['get', 'set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1MUTE ?`, /%1MUTE=(\d+)/i, tags);
                return match[1] === '1';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%1MUTE ${mute ? '1' : '0'}`, /%1MUTE=(OK|ERR)/, tags);
                return match[1].toLowerCase() === 'ok' ? mute : this.state.volumeMute.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 3000, controls: ['power', 'videoInput'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.state.busy.update(false);
            this.config = config;
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield CommandSocketInitializer.initialize(this.socket, [
                {
                    errorCode: 'verifyFailed',
                    next: /UserName:/i,
                    succeed: /Login successfully/i,
                },
                {
                    errorCode: 'authFailed',
                    send: (cred) => {
                        var _a;
                        return (_a = cred.username) !== null && _a !== void 0 ? _a : 'sunbrite';
                    },
                    next: /Password:/i,
                    fail: /Invalid Login/i,
                },
                {
                    errorCode: 'authFailed',
                    send: (cred) => {
                        var _a;
                        return (_a = cred.password) !== null && _a !== void 0 ? _a : 'sunbrite';
                    },
                    succeed: /Login Successfully/i,
                    fail: /Invalid Login/i,
                },
            ], credentials);
            if (result !== 'connected') {
                // Try without login credentials since some models don't require authentication
                result = yield CommandSocketInitializer.initialize(this.socket, [
                    {
                        errorCode: 'verifyFailed',
                        send: () => `%1POWR ?`,
                        next: /%1POWR=\d/i,
                        succeed: /Login successfully/i,
                    },
                ], credentials);
            }
            return result;
        });
    }
}
Sunbrite.driverType = 'socketDriver';
Sunbrite.key = '-O33B4Sph-P7Vb3EhAUg';
Sunbrite.socketOptions = [
    {
        commandExtractor: {
            terminators: ['\r'],
        },
        sendTerminator: '\r',
        port: 4352,
    },
];
